import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { Box } from 'lucide-react';
import { servicePricing } from '../../mockData';

const Blockchain = () => {
  const features = [
    {
      title: "Smart Contracts",
      description: "Secure, audited smart contracts on Ethereum, Solana, or other chains"
    },
    {
      title: "DApp Development",
      description: "Full-stack decentralized applications with Web3 integration"
    },
    {
      title: "NFT Marketplaces",
      description: "Create and launch NFT platforms with minting and trading"
    },
    {
      title: "Wallet Integration",
      description: "Connect with MetaMask, WalletConnect, and other wallets"
    },
    {
      title: "Token Development",
      description: "Create custom ERC-20, BEP-20, or other token standards"
    },
    {
      title: "Security Audits",
      description: "Comprehensive security reviews before mainnet deployment"
    }
  ];

  const benefits = [
    {
      title: "Transparency & Trust",
      description: "Blockchain's immutable ledger builds trust with users and partners"
    },
    {
      title: "Reduced Costs",
      description: "Eliminate intermediaries and reduce transaction fees"
    },
    {
      title: "Global Reach",
      description: "Borderless transactions accessible to anyone with internet"
    },
    {
      title: "Innovation Leader",
      description: "Position your business at the forefront of Web3 technology"
    }
  ];

  const process = [
    {
      title: "Blockchain Selection",
      description: "Choose the right blockchain based on your use case and requirements"
    },
    {
      title: "Smart Contract Development",
      description: "Write, test, and audit smart contracts with best practices"
    },
    {
      title: "Frontend Integration",
      description: "Build user-friendly interfaces for interacting with blockchain"
    },
    {
      title: "Deployment & Monitoring",
      description: "Deploy to mainnet and monitor performance and security"
    }
  ];

  return (
    <ServicePageTemplate
      title="Blockchain Development"
      subtitle="Build the Future with Web3"
      description="Secure, scalable blockchain solutions from smart contracts to full DApps. We help you leverage the power of decentralization for your business."
      features={features}
      benefits={benefits}
      pricing={servicePricing.blockchain}
      icon={Box}
      bgColor="#88a2ff"
      process={process}
    />
  );
};

export default Blockchain;